import React, { useCallback } from "react";
import { DebounceInput } from "react-debounce-input";
import styled from "styled-components";
import { Form } from "react-bootstrap";

const StyledFormControl = styled(Form.Control)`
  width: 240px;
`;

const Error = styled.div`
  font-size: 12px;
  list-style: none;
  background-color: #f4dbdb;
  width: fit-content;
  padding: 3px 5px;
  margin-top: 4px;
  border-radius: 5px;
  color: #dc3545;
`;

export function ArrayAsString(props: any) {
  const handleChange = useCallback(
    data => {
      const codes = data.target.value.split(",").filter((it: string) => it);
      props.onChange(codes);
    },
    [props]
  );

  const error =
    (Object.keys(props.errorSchema).length &&
      props.errorSchema[0] &&
      props.errorSchema[0].__errors &&
      props.errorSchema[0].__errors[0]) ||
    (props.errorSchema[1] && props.errorSchema[1].__errors && props.errorSchema[1].__errors[0]);
  return (
    <>
      <label>{props?.schema?.title}</label>
      <DebounceInput
        element={StyledFormControl}
        minLength={0}
        debounceTimeout={100}
        type="text"
        value={Array.isArray(props.formData) && props.formData.join(",")}
        onChange={data => handleChange(data)}
        readOnly={props.readonly || props.disabled}
      />
      {!!error && <Error className="text-danger">{error}</Error>}
    </>
  );
}
